/* GDPR consent — persisted in localStorage. Analytics only loads after
   an explicit "accept" (privacy-first: nothing tracks before consent). */
const KEY = 'curatedhomes.consent.v1'

export function getConsent() {
  try {
    return localStorage.getItem(KEY) // 'accepted' | 'declined' | null
  } catch {
    return null
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(KEY, value)
  } catch {
    // ignore (private mode / storage disabled)
  }
  window.dispatchEvent(new CustomEvent('curatedhomes:consent', { detail: value }))
}
